<template>
  <main>
    <div class="container-fluid message">
      <TopTemplate>
        <template #right-element>
          <div class="top-btn">
            <router-link v-if="cantineList.length > 0" :to="{name: 'editCantine'}" class="btn button btn-primary btn-edit" :disabled="loading">
              <i class="icon-edit-03" />
              {{ $t("button.edit") }}
            </router-link>
            
            <router-link v-if ="affich && cantineList.length === 0" :to="{name: 'addCantine'}" class="btn button btn-primary" :disabled="loading">
              
              <i class="icon-Add" />
              {{ $t("title.addMenu") }}
            </router-link>
          </div>
        </template>
        <template #left-element>
          <h3>{{ $t("title.cantine") }}</h3>
        </template>
      </TopTemplate>
      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-if="!loading && cantineList.length === 0" class="card text-center d-block pt-2 pb-2">
                <span>{{ $t("common.emptyCantine") }}</span>
              </div>

      <div v-if="!loading && cantineList.length > 0">
        <div class="table message-list custom-table">
          <div class>
            <div class="row">
              <div class="col-md-12">
                <div class="table__wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th class="col-md-2">{{ $t("cantine.tab.day") }}</th>
                        <th class="col-md-2">{{ $t("cantine.tab.gouterMorning") }}</th>
                        <th class="col-md-2">{{ $t("cantine.tab.dejeuner") }}</th>
                        <th class="col-md-2">{{ $t("cantine.tab.gouterAfternon") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cantine in cantineList" :key="cantine.id">
                        <td class="col-md-2 day-custom">{{ cantine.day }}</td>
                        <td class="col-md-2">{{ cantine.morning_snack }}</td>
                        <td class="col-md-2">{{ cantine.lunch }}</td>
                        <td class="col-md-2">{{ cantine.afternoon_snack }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import CantinesService from "../../services/cantine.service";
import _ from "lodash";
export default {
  name: "cantineList",
  components: {
    TopTemplate,
  },
  data() {
    return {
      loading: false,
      cantineList: [],
      affich:false,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.ListCantines();
  },
  methods: {
    ListCantines() {
      this.loading = true;
      CantinesService.getAll({})
        .then((response) => {
          this.cantineList = response.data.planning;
          this.loading = false;
          this.affich = true;
        })
        .catch((error) => {
           if (error.response && error.response.status === 403) {
              this.$router.push('/error-403');
            }
        });
    },
  },
};
</script>
<style scoped>
.top-btn {
  display: flex;
}
.btn-edit {
  margin-right: 10px;
}
.day-custom {
  text-transform: capitalize;
}

</style>
